import { http } from '@pendo/http';

export function promoteToRoadmap ({ vocItemId, roadmapId }) {
    return http
        .post(`/api/s/_SID_/vocItem/${vocItemId}/roadmap/${roadmapId}/promote`, {
            headers: { 'Content-Type': 'application/json' },
        })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function getRoadmapPromoted ({ vocItemId }) {
    return http
        .get(`/api/s/_SID_/vocItem/${vocItemId}/roadmap/promoted`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}
